// extracted by mini-css-extract-plugin
export default {"editorPage":"EditorPage_editorPage__cgdyT","leftSidebarWrapper":"EditorPage_leftSidebarWrapper__Ycobv","workspaceWrapper":"EditorPage_workspaceWrapper__peqAZ"};